import NewPayoutReportListPage from './NewPayoutReportListPage';

export default NewPayoutReportListPage;
